import React, { useState } from 'react';
import { Button, Card, CardHeader, Table } from '@opendate-app/setlist';

const COLLAPSED_ROWS = 10;

function ExpandableTableCard({ title, supportingText, columns, rows, getRowKey }) {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? rows : rows.slice(0, COLLAPSED_ROWS);
  const footer = rows.length > COLLAPSED_ROWS && (
    <div className="px-4 py-3">
      <Button variant="link-color" size="sm" onClick={() => setExpanded(!expanded)}>
        {expanded ? 'Show Less' : 'Show All'}
      </Button>
    </div>
  );

  return (
    <Card padding="none" header={<CardHeader title={title} supportingText={supportingText} />} footer={footer || undefined}>
      <Table columns={columns} data={visible} getRowKey={getRowKey} />
    </Card>
  );
}

export default ExpandableTableCard;
